import React from "react";
import { Form } from "react-bootstrap";
import "./input.css";

export default function Input({
  type,
  placeholder,
  value,
  id,
  size,
  onChange,
  isValid,
  className,
  accept,
  as,
  ref,
  max,
  min,
  step,
  ariaLabel,
  ariaDescribedby,
  maxLength,
  autoComplete,
  style,
  minLength,
  onBlur,
  onSelect,
  multiple,
  required,
  disabled,
  ...props
}) {
  return (
    <Form.Control
      as={as}
      type={type}
      placeholder={placeholder}
      value={value}
      id={id}
      size={size}
      onChange={onChange}
      isValid={isValid}
      accept={accept}
      ref={ref}
      max={max}
      min={min}
      step={step}
      aria-label={ariaLabel}
      aria-describedby={ariaDescribedby}
      minLength={minLength}
      maxLength={maxLength}
      autoComplete={autoComplete}
      style={style}
      onBlur={onBlur}
      onSelect={onSelect}
      multiple={multiple}
      required={required}
      disabled={disabled}
      className={`common-input ${className}`}
      {...props}
    />
  );
}
